export default "/images/vendor/flag-icon-css/flags/1x1/es.svg?b3825b28f7a64779d80d6a5da10cfa08";